import React from "react";

interface ZoClubLogoProps {
  className?: string;
  logoClassName?: string;
}

const ZoClubLogo: React.FC<ZoClubLogoProps> = ({
  className,
  logoClassName = "fill-current text-orange font-medium",
}) => {
  return (
    <svg width={16} height={17} viewBox="0 0 16 17" className={className}>
      <path
        d="m0 3.75 2.982 9.38h1.652L1.677 3.75H0Zm14.347 0-3.13 9.38h1.677L16 3.75h-1.652ZM5.582 8.695h2.423l-2.634 3.317v1.118h5.268v-1.602H8.07l2.656-3.318V7.092H5.582v1.603Z"
        className={logoClassName}
      />
    </svg>
  );
};

export default ZoClubLogo;
